import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const machineMeta = [product.category_machine_number && `Maschinen Nummer ${product.category_machine_number}`, product.category_year && `Baujahr ${product.category_year}`].filter(Boolean).join(" · ");
  return (
    <Link to={`/produkte/${product.id}`} className="product-list-card" data-testid={`product-card-${product.id}`}>
      <div>
        <h3 data-testid={`product-title-${product.id}`}>{product.title}</h3>
        {machineMeta && <span className="product-machine-meta" data-testid={`product-machine-meta-${product.id}`}>{machineMeta}</span>}
      </div>
      <p data-testid={`product-part-count-${product.id}`}>{product.part_count} Bauteile</p>
    </Link>
  );
}